<template>
  <div class="contact_index">
    <div class="contact_index_text">
      <p style="font-size: 22px;margin-bottom: 10px">About Us</p>
      <p style="font-size: 20px;margin-bottom: 0">Headquartered in the US, SIG is a global proprietary trading</p>
      <p style="font-size: 20px;margin-bottom: 0">proprietary trading and broker-dealer</p>
      <p style="font-size: 20px;margin-bottom: 0">firm founded with an entrepreneurial</p>
      <p style="font-size: 20px;margin-bottom: 0">mindset and a rigorous analytical</p>
      <p style="font-size: 20px;margin-bottom: 10px">approach to decision making.</p>
      <p style="font-size: 14px;margin-bottom: 0">Over the past 30 years, SIG's business thrives at the
        intersection </p>
      <p style="font-size: 14px;margin-bottom: 0">of trading, quantitative research, and technology.</p>
      <p style="font-size: 14px">SIG now has over 1,800 employees worldwide.</p>

      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Contact_index_en_m',
  components: {DownOutlined,},
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }

}
</script>
<style scoped>
.contact_index {
  background-image: url("../../../assets/background/contact_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
  text-align: center;
}

.contact_index_text {
  padding-top: 30vh;
}

.index_down {
  padding-top: 2vh;
}
</style>